import Vue from 'vue';
import Vuex from 'vuex';
import { AuthStoreModule } from '@auth/store/auth.store';
import { TenantStoreModule } from '@core/store/tenant.store';
import { BookingModule } from '@bookings/store/booking.store';
import { BookingEventModule } from '@bookings/store/booking-event.store';
import { ConfigStoreModule } from '@core/store/config.store';
import { TableStoreModule } from '@core/store/table.store';
import { InputTableStoreModule } from '@core/store/input-table.store';
import { SelectStoreModule } from '@core/store/select.store';
import { MediaStoreModule } from '@core/store/media.store';
import { MessageStoreModule } from '@communications/store/message.store';
import { DetailsStoreModule } from '@core/store/details.store';
import { CenterSettingStoreModule } from '@core/store/center-setting.store';
import { ShoppingCartStoreModule } from '@accounting/store/shopping-cart.store';
import { TranslationReportStoreModule } from '@dev/store/translation-report.store';
import { PosStoreModule } from '@pos/store/pos.store';
import { PaymentTerminalsStoreModule } from '@payment-terminals/store/payment-terminals.store';
import { InvoiceCountsStoreModule } from '@accounting/store/invoice-counts.store';
import { EntryResyncStore } from '@entries/store/resync.store';
import { SubscriptionResyncStore } from '@subscriptions/store/resync.store';
import { AttendeeResyncStore } from '@activities/store/resync.store';
import { ActivitySessionResyncStore } from '@activities/store/activity-session-resync.store';

const translationReportsActivated = process.env.VUE_APP_ACTIVATE_TRANSLATION_REPORTS === 'true';

Vue.use(Vuex);

const modules = {
  auth: AuthStoreModule,
  tenant: TenantStoreModule,
  booking: BookingModule,
  bookingEvent: BookingEventModule,
  config: ConfigStoreModule,
  table: TableStoreModule,
  inputTable: InputTableStoreModule,
  select: SelectStoreModule,
  media: MediaStoreModule,
  message: MessageStoreModule,
  details: DetailsStoreModule,
  centerSettings: CenterSettingStoreModule,
  shoppingCart: ShoppingCartStoreModule,
  invoiceCounts: InvoiceCountsStoreModule,
  pos: PosStoreModule,
  paymentTerminals: PaymentTerminalsStoreModule,
  entryResyncStore: EntryResyncStore,
  subscriptionResyncStore: SubscriptionResyncStore,
  attendeeResyncStore: AttendeeResyncStore,
  activitySessionResyncStore: ActivitySessionResyncStore,
};

if (translationReportsActivated) {
  modules['tReport'] = TranslationReportStoreModule;
}

export default new Vuex.Store({
  strict: false, // Change to true for debugging propose
  state: {
    version: process.env.APP_VUE_VERSION || '0.1.0',
  },
  mutations: {},
  actions: {},
  modules: modules,
});
